/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { NonceAttestation } from './NonceAttestation';
import {
    instanceOfNonceAttestation,
    NonceAttestationFromJSON,
    NonceAttestationFromJSONTyped,
    NonceAttestationToJSON,
} from './NonceAttestation';
import type { OTPAttestation } from './OTPAttestation';
import {
    instanceOfOTPAttestation,
    OTPAttestationFromJSON,
    OTPAttestationFromJSONTyped,
    OTPAttestationToJSON,
} from './OTPAttestation';
import type { PasswordResetAttestation } from './PasswordResetAttestation';
import {
    instanceOfPasswordResetAttestation,
    PasswordResetAttestationFromJSON,
    PasswordResetAttestationFromJSONTyped,
    PasswordResetAttestationToJSON,
} from './PasswordResetAttestation';
import type { PasswordSetAttestation } from './PasswordSetAttestation';
import {
    instanceOfPasswordSetAttestation,
    PasswordSetAttestationFromJSON,
    PasswordSetAttestationFromJSONTyped,
    PasswordSetAttestationToJSON,
} from './PasswordSetAttestation';
import type { PasswordVerifyAttestation } from './PasswordVerifyAttestation';
import {
    instanceOfPasswordVerifyAttestation,
    PasswordVerifyAttestationFromJSON,
    PasswordVerifyAttestationFromJSONTyped,
    PasswordVerifyAttestationToJSON,
} from './PasswordVerifyAttestation';
import type { TOTPRegisterAttestation } from './TOTPRegisterAttestation';
import {
    instanceOfTOTPRegisterAttestation,
    TOTPRegisterAttestationFromJSON,
    TOTPRegisterAttestationFromJSONTyped,
    TOTPRegisterAttestationToJSON,
} from './TOTPRegisterAttestation';
import type { TOTPVerifyAttestation } from './TOTPVerifyAttestation';
import {
    instanceOfTOTPVerifyAttestation,
    TOTPVerifyAttestationFromJSON,
    TOTPVerifyAttestationFromJSONTyped,
    TOTPVerifyAttestationToJSON,
} from './TOTPVerifyAttestation';
import type { WebAuthnCreateAttestation } from './WebAuthnCreateAttestation';
import {
    instanceOfWebAuthnCreateAttestation,
    WebAuthnCreateAttestationFromJSON,
    WebAuthnCreateAttestationFromJSONTyped,
    WebAuthnCreateAttestationToJSON,
} from './WebAuthnCreateAttestation';
import type { WebAuthnGetAttestation } from './WebAuthnGetAttestation';
import {
    instanceOfWebAuthnGetAttestation,
    WebAuthnGetAttestationFromJSON,
    WebAuthnGetAttestationFromJSONTyped,
    WebAuthnGetAttestationToJSON,
} from './WebAuthnGetAttestation';

/**
 * @type Attestation
 * 
 * @export
 */
export type Attestation = { challenge_type: 'nonce' } & NonceAttestation | { challenge_type: 'otp' } & OTPAttestation | { challenge_type: 'password_reset' } & PasswordResetAttestation | { challenge_type: 'password_set' } & PasswordSetAttestation | { challenge_type: 'password_verify' } & PasswordVerifyAttestation | { challenge_type: 'totp_register' } & TOTPRegisterAttestation | { challenge_type: 'totp_verify' } & TOTPVerifyAttestation | { challenge_type: 'webauthn_create' } & WebAuthnCreateAttestation | { challenge_type: 'webauthn_get' } & WebAuthnGetAttestation;

export function AttestationFromJSON(json: any): Attestation {
    return AttestationFromJSONTyped(json, false);
}

export function AttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Attestation {
    if (json == null) {
        return json;
    }
    switch (json['challenge_type']) {
        case 'nonce':
            return Object.assign({}, NonceAttestationFromJSONTyped(json, true), { challenge_type: 'nonce' } as const);
        case 'otp':
            return Object.assign({}, OTPAttestationFromJSONTyped(json, true), { challenge_type: 'otp' } as const);
        case 'password_reset':
            return Object.assign({}, PasswordResetAttestationFromJSONTyped(json, true), { challenge_type: 'password_reset' } as const);
        case 'password_set':
            return Object.assign({}, PasswordSetAttestationFromJSONTyped(json, true), { challenge_type: 'password_set' } as const);
        case 'password_verify':
            return Object.assign({}, PasswordVerifyAttestationFromJSONTyped(json, true), { challenge_type: 'password_verify' } as const);
        case 'totp_register':
            return Object.assign({}, TOTPRegisterAttestationFromJSONTyped(json, true), { challenge_type: 'totp_register' } as const);
        case 'totp_verify':
            return Object.assign({}, TOTPVerifyAttestationFromJSONTyped(json, true), { challenge_type: 'totp_verify' } as const);
        case 'webauthn_create':
            return Object.assign({}, WebAuthnCreateAttestationFromJSONTyped(json, true), { challenge_type: 'webauthn_create' } as const);
        case 'webauthn_get':
            return Object.assign({}, WebAuthnGetAttestationFromJSONTyped(json, true), { challenge_type: 'webauthn_get' } as const);
        default:
            return json;
    }
}

export function AttestationToJSON(json: any): any {
    return AttestationToJSONTyped(json, false);
}

export function AttestationToJSONTyped(value?: Attestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['challenge_type']) {
        case 'nonce':
            return Object.assign({}, NonceAttestationToJSON(value), { challenge_type: 'nonce' } as const);
        case 'otp':
            return Object.assign({}, OTPAttestationToJSON(value), { challenge_type: 'otp' } as const);
        case 'password_reset':
            return Object.assign({}, PasswordResetAttestationToJSON(value), { challenge_type: 'password_reset' } as const);
        case 'password_set':
            return Object.assign({}, PasswordSetAttestationToJSON(value), { challenge_type: 'password_set' } as const);
        case 'password_verify':
            return Object.assign({}, PasswordVerifyAttestationToJSON(value), { challenge_type: 'password_verify' } as const);
        case 'totp_register':
            return Object.assign({}, TOTPRegisterAttestationToJSON(value), { challenge_type: 'totp_register' } as const);
        case 'totp_verify':
            return Object.assign({}, TOTPVerifyAttestationToJSON(value), { challenge_type: 'totp_verify' } as const);
        case 'webauthn_create':
            return Object.assign({}, WebAuthnCreateAttestationToJSON(value), { challenge_type: 'webauthn_create' } as const);
        case 'webauthn_get':
            return Object.assign({}, WebAuthnGetAttestationToJSON(value), { challenge_type: 'webauthn_get' } as const);
        default:
            return value;
    }
}

